import React, { createElement, FunctionComponent, ReactElement, useMemo } from 'react';
import { useDrawers } from '@hooks/useDrawers';
import { OrderInfoDrawer } from '@modules/drawers/page/order-info';
import { Icon } from '@iconify/react';
import { Button } from '@nextui-org/react';
import { RecipesDrawer } from './recipes';
import { ShoppingCar } from './shopping-car';

const Drawer = () => {
  const { isOpen, type, onClose } = useDrawers();
  interface CustomDivElement extends HTMLDivElement {
    syncForms?: () => void;
  }
  const ref = React.createRef<any>();
  const renderOption: Record<string, FunctionComponent<any>> = useMemo(
    () => ({
      recipe: RecipesDrawer,
      order: OrderInfoDrawer,
      car: ShoppingCar,
    }),
    [type]
  );

  if (!type) {
    return null;
  }
  const selectedOption = renderOption[type];
  if (!selectedOption) {
    return null;
  }

  const handleClose = () => {
    // Llama a syncForms antes de cerrar el modal
    if (ref.current?.syncForms) {
      console.log('entreeee')
      ref.current.syncForms?.();
    }
    onClose(); // Cierra el modal
  };

  return (
    <>
      {/* Overlay (oscurece el fondo) */}
      {/* <div */}
      {/*   className="fixed inset-0 bg-black bg-opacity-50 z-40" */}
      {/*   onClick={onClose} */}
      {/* ></div> */}

      <div
        className={`fixed top-0 right-0 h-full w-64  bg-white shadow-lg z-50 transform transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <Button
          isIconOnly
          color="default"
          aria-label="close"
          size="sm"
          className="rounded-full  absolute top-2 right-1 z-[10000]"
          onClick={handleClose}
        >
          <Icon icon="mdi:close-thick" color="black" fontSize={18} />
        </Button>
        {createElement(selectedOption, { ref })}
      </div>
    </>
  );
};

export default Drawer;
